




















































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ModalComponent from '@/shared/modal/modal.component.vue'
import ModalOptions from '@/shared/modal/modal-options.entity';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
  },
})
export default class BusinessUnitMacro extends Vue {
  @Prop({ required: true }) show!: boolean;

  @Prop({ required: true, default: '' }) businessUnitId!: string;

  @Prop({ required: true, default: '' }) observation!: string;

  @Prop({ required: true, default: 'Observação da Macro' }) externalTitle!: string;

  private iconToolTip = 'Clique na "Macro" para adicionar';

  private macros: string[] = [];

  created() {
    this.getMacros();
  }

  get options(): ModalOptions {
    return {
      title: this.externalTitle,
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 1024,
      persistent: true,
    }
  }

  private ok(): any {
    this.$emit('ok', this.observation);
  }

  private cancel(): void {
    this.$emit('cancel');
  }

  @Watch('show')
  getMacros() {
    if (this.businessUnitId && this.show === true) {
      BusinessUnitService.getMacros(this.businessUnitId)
        .then((response) => {
          this.macros = response;
        })
        .catch(VbSnackbarService.handleHttpError);
    }
  }

  insertMacro(macro: string) {
    const observationInput = document.getElementById('observation-input') as any;

    const startPos = observationInput.selectionStart;
    const endPos = observationInput.selectionEnd;
    observationInput.value = observationInput.value.substring(0, startPos)
      + macro
      + observationInput.value.substring(endPos, observationInput.value.length);
    this.observation = observationInput.value;
    observationInput.focus();

    const macroLength = macro.length;
    observationInput.setSelectionRange(startPos + macroLength, startPos + macroLength);
  }
}
